/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Waypoint } from 'vue-waypoint'
import PhotoStream from './components/photo-stream/PhotoStream'
import Toasted from 'vue-toasted';
import Multiselect from "vue-multiselect";
import checkScroll from "./attendee_web/plugins"
import formHelpers from './attendee_web/formHelpers'
import barcodes from './attendee_web/barcodes'
import PoweredByEventfinity from './components/global/PoweredByEventfinity.vue';
import { isPWA } from './pwaUtils'

const { initHtml5QrcodeScanner } = barcodes


// conditionally require bootstrap javascript and bootstrap select, should remove once oa 
// is refactored so its just import 'bootstrap' and require('bootstrap-select')
// conditional_requires is hack
import 'bootstrap'
import flatpickr from "flatpickr";
import 'datatables.net-plugins/sorting/datetime-moment.js';
// require('./conditional_requires/bootstrap.js')
require('./conditional_requires/bootstrap-select.js');
require('daterangepicker/daterangepicker.js')
var $ = require('jquery')

window.MaestroIFrameSDK = require('@maestro_io/iframe-sdk').default

var ajaxHeader = {
  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
}

$.ajaxSetup({
    headers: ajaxHeader
});

window._ = require('lodash');
window.moment = require('moment-timezone');

// THIS SHOULD BE OBSOLETE, javascript is for 3.4 bootstrap which I do not think we 
// have any trace left off
// require('bootstrap-sass');
const { validateRequiredVisibleChildFields } = formHelpers
window.validateRequiredVisibleChildFields = validateRequiredVisibleChildFields

import Vue from 'vue';
window.Vue = Vue;
window.axios = require('axios');
window.EventBus = new Vue();

var axiosHeader = {
  'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
  'X-Requested-With': 'XMLHttpRequest'
};

window.axios.defaults.headers.common = axiosHeader;

// window.axios.defaults.headers.common = {
//     'X-CSRF-TOKEN': window.Laravel.csrfToken,
//     'X-Requested-With': 'XMLHttpRequest'
// };


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
// var sentryEnv = process.env.MIX_ENVIRONMENT || 'local'
// Sentry.init({
//   dsn: 'https://462118091d1544d1a09e2b504bff1da7@o310434.ingest.sentry.io/5320677',
//   environment: sentryEnv,
//   integrations: [new VueIntegration({ Vue, attachProps: true })],
// });

// window.Sentry = Sentry


import Echo from "laravel-echo"

// window.io = require('socket.io-client');
window.Pusher = require('pusher-js');
window.heic2any = require("heic2any");


var separate = window.location.hostname.split('.');
separate.shift();
var currentdomain = separate.join('.');


// if (process.env.MIX_SOCKET_SERVER) {
//   window.Echo = new Echo({
//     broadcaster: 'socket.io',
//     host: process.env.MIX_SOCKET_SERVER,
//     auth:
//     {
//       headers:{},
//       host : window.location.origin
//     }
//   });
// } else if (process.env.MIX_SOCKET_SERVER_PORT) {
//   window.Echo = new Echo({
//     broadcaster: 'socket.io',
//     host: window.location.hostname+':'+process.env.MIX_SOCKET_SERVER_PORT,
//     auth:
//     {
//       headers:{},
//       host : window.location.origin
//     }
//   });
// } else {
//   window.Echo = new Echo({
//     broadcaster: 'socket.io',
//     host: window.location.origin,
//     auth:
//     {
//       headers:{},
//       host : window.location.origin+'/socket'
//     }
//   });
// }

var xcsrfToken = document.querySelector('meta[name="csrf-token"]')
if (xcsrfToken != null) {
  xcsrfToken = xcsrfToken.content
}

if (xcsrfToken != null) {
  var echoInstance = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_KEY,
    cluster: process.env.MIX_PUSHER_CLUSTER,
    forceTLS: true,
    authEndpoint: '/broadcasting/auth',
    auth: {
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      }
    }
  });

  window.EchoSpy = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_KEY,
    cluster: process.env.MIX_PUSHER_CLUSTER,
    forceTLS: true,
    authEndpoint: '/broadcasting/auth',
    auth: {
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        spy: true
      }
    }
  });
}


window.Echo = echoInstance

import messages from './ll_messages';
import Lang from 'lang.js';
import initMobileNavToggles from "./attendee_web/initMobileNavToggles";


const default_locale = window.default_locale;
const fallback_locale = 'en';

window.messages = messages
window._lang = new Lang( {
  messages,
  locale: default_locale,
  fallback: fallback_locale
});

Vue.prototype.lang = _lang
Vue.prototype.$fetchStates = {idle: 'IDLE',fetching: 'FETCHING',success: 'SUCCESS',error: 'ERROR'}
Vue.use(Waypoint);

// Global
Vue.component("powered-by-eventfinity", require("./components/global/PoweredByEventfinity.vue").default);
Vue.component("multi-select", Multiselect);
Vue.component( "photo-stream-modal", require("./components/photo-stream/PhotoStreamModal.vue").default);
Vue.component("photo-stream-search", require("./components/photo-stream/PhotoStreamSearch.vue").default);
Vue.component( "photo-stream", require("./components/photo-stream/PhotoStream.vue").default);
Vue.component( "attendee-tag-search", require("./components/photo-stream/AttendeeTagSearch.vue").default);
Vue.component("photo-stream-column", require("./components/photo-stream/PhotoStreamColumn.vue").default)
Vue.component( "photo-card", require("./components/photo-stream/PhotoCard.vue").default);
Vue.component( "photo-stream-comment", require("./components/photo-stream/Comment.vue").default);
Vue.component( "photo-form", require("./components/photo-stream/PnotoForm.vue").default);
Vue.component( "select-timezone", require("./components/attendees/SelectTimezone.vue").default);
Vue.component( "select-language", require("./components/attendees/SelectLanguage.vue").default);
Vue.component( "suite-card", require("./components/attendees/SuiteCard.vue").default);
Vue.component( "avatar-bubble", require("./components/attendees/AvatarBubble.vue").default);
Vue.component( "global-chat-member-card", require("./components/global-chat/GlobalChatMemberCard.vue").default);
Vue.component( "global-chat-placeholder-member-card", require("./components/global-chat/GlobalChatPlaceholderMemberCard.vue").default);
Vue.component( "global-chat-message", require("./components/global-chat/GlobalChatMessage.vue").default);
Vue.component( "global-chat-placeholder-message", require("./components/global-chat/GlobalChatPlaceholderMessage.vue").default);
Vue.component( "global-chat-message-empty-state", require("./components/global-chat/GlobalChatMessageEmptyState.vue").default);
Vue.component( "global-chat-room-item", require("./components/global-chat/GlobalChatRoomItem.vue").default);
Vue.component( "global-chat-modal", require("./components/global-chat/GlobalChatModal.vue").default);
Vue.component( "global-chat-avatar-bubble", require("./components/global-chat/GlobalChatAvatarBubble.vue").default);
Vue.component( "directory-pills-filter", require("./components/directories/DirectoryPillsFilter.vue").default);
Vue.component( "directory-default-filter", require("./components/directories/DirectoryDefaultFilter.vue").default);

// video playlists
Vue.component('video-page-plugin-show', require("./components/video-page-plugins/VideoPagePluginShow.vue").default);
Vue.component( "video-playlist-attendee-show", require("./components/video-playlists/VideoPlaylistAttendeeShow.vue").default);
Vue.component( "grid-playlist-show", require("./components/video-playlists/GridPlaylistShow.vue").default);
Vue.component( "mux-video-provider", require("./components/video/MuxVideoProvider.vue").default);


Vue.component('attendee-video-asset-show', require('./components/video-assets/AttendeeVideoAssetShow.vue').default);
Vue.component( "plugin-popup", require("./components/video-assets/PluginPopup.vue").default);
Vue.component( "video-asset-duration", require("./components/video-assets/VideoAssetDuration.vue").default);

// Agenda
Vue.component( "homescreen-bookmark-toggle", require("./components/agenda/HomescreenBookmarkToggle.vue").default);
Vue.component( "agenda-bookmark-toggle", require("./components/agenda/AgendaBookmarkToggle.vue").default);

// Add to calendar
Vue.component( "add-to-calendar-modal", require("./components/agenda/AddToCalendarModal.vue").default);
Vue.component( "add-to-calendar-button", require("./components/agenda/AddToCalendarButton.vue").default);

// Likeable component
Vue.component( "likeable-item", require("./components/agenda/LikeableItem.vue").default);
Vue.component( "survey-popup", require("./components/forms/SurveyPopup.vue").default);

// Live streams
Vue.component( "attendee-live-stream-show", require("./components/live-streams/AttendeeLiveStreamShow.vue").default);
Vue.component("video-config-provider", require("./components/live-streams/VideoConfigProvider.vue").default);
Vue.component(
  "points-allocation-page",
  require("./components/points-allocation/PointsAllocationPage.vue").default
);

Vue.component(
  "points-allocation-group",
  require("./components/points-allocation/PointsAllocationGroup.vue").default
);

Vue.component(
  'app-settings-modal',
  require('./components/AppSettingsModal.vue').default
);

Vue.component(
  "chatbot",
  require("./components/chatbots/Chatbot.vue").default
);

// Legacy Photostream
Vue.component( "photo-stream-modal-legacy", require("./components/photo-stream/PhotoStreamModal-legacy.vue").default);
Vue.component( "photo-stream-legacy", require("./components/photo-stream/PhotoStream-legacy.vue").default);
Vue.component( "photo-card-legacy", require("./components/photo-stream/PhotoCard-legacy.vue").default);
Vue.component( "photo-stream-comment-legacy", require("./components/photo-stream/Comment-legacy.vue").default);
Vue.component("photo-form-legacy", require("./components/photo-stream/PnotoForm-legacy.vue").default)
Vue.component("global-chat-broadcast-input", require("./components/global-chat/GlobalChatBroadcastInput.vue").default);
Vue.component( "global-chat-input", require("./components/global-chat/GlobalChatInput.vue").default);
Vue.component( "directory-event-attendee-action", require("./components/directories/EventAttendeeAction.vue").default);
Vue.component( "chat-button", require("./components/directories/ChatButton.vue").default);
Vue.component("stream-conductor-presenter", require("./components/stream-conductors/StreamConductorPresenter.vue").default)

// Form
Vue.component( "stripe-checkout-form", require('./components/forms/StripeCheckout.vue').default);
Vue.component( "visa-checkout-form", require('./components/forms/VisaCheckout.vue').default);
Vue.component( "form-domain-validation", require("./components/forms/FormDomainValidation.vue").default);
Vue.component( "reg-code-validation", require("./components/forms/RegistrationCodeValidation.vue").default);

// Live Now Indicator
Vue.component( "live-now-indicators", require("./components/agenda/LiveNowIndicator.vue").default);

Vue.component( "attendee-order-history-index", require("./components/ecommerce/AttendeeOrderHistoryIndex.vue").default);
Vue.component( "attendee-order-history-show", require("./components/ecommerce/AttendeeOrderHistoryShow.vue").default);
Vue.component( "ecommerce-receipt", require("./components/ecommerce/EcommerceReceipt.vue").default);

Vue.component("ticket-list", require("./components/event-attendee-transactions/TicketList.vue").default);
Vue.component("chat-agent-kiosk", require("./components/chatbots/ChatAgentKiosk.vue").default);



var GlobalChatController = require('./components/global-chat/global-chat-controller.js').default
var pingEventAttendeeActive = require('./components/event-presence/eventPresencePinger.js').default
var joinEventAttendeeOnlineChannel = require('./components/event-presence/joinEventAttendeeOnlineChannel.js').default
var initEventAttendeePluginVisit = require('./components/event-presence/eventAttendeePluginVisit.js').default
var initAttendeeNotifications = require("./attendee_web/notifications/initAttendeeNotifications.js").default;

var attendeeProfileShow = require('./components/attendee-profile/attendeeProfileShow.js').default


require('./services/http.js')


var GlobalNavigationController = require('./components/navigation/navigation-controller.js').default

window.initAppSettingsModal = function (opts={}) {
  var { eventAttendeeId } = opts
  if (!eventAttendeeId) {
    throw new Error('eventAttendeeId is required')
  }
  
  return new Vue({
    el: '#app-settings-modal',
    data: { 
      eventAttendeeId,
      modalVisible: false
    },
    methods: {
      openAppSettingsModal () {
        this.modalVisible = true
      },
      closeModal () {
        this.modalVisible = false
      }
    },
  })
}

$(function () {
  Vue.use(Toasted)

  // Set up base event script
  if (document.querySelector('.baseEvent')) {
    require('./baseEvent.js')
    if (document.getElementById('powered-by-eventfinity')) {
      new Vue({
        render: h => h(PoweredByEventfinity)
      }).$mount('#powered-by-eventfinity');
    }
  }

  var attendeeProfileDiv = document.getElementsByClassName('directory-attendee-actions') && document.getElementsByClassName('directory-attendee-actions')[0]
  if (attendeeProfileDiv) {
    attendeeProfileShow(attendeeProfileDiv)
  }

  var joinedOnlineChannelFromChat = false
  if (document.getElementsByClassName('global-chat')) {
    var globalChatData = window.globalChatData
    var currentEventAttendee = globalChatData && globalChatData.currentEventAttendee
    if (currentEventAttendee) {
      window.globalChatController = GlobalChatController('.global-chat', {
        currentEventAttendee: globalChatData.currentEventAttendee,
        currentEvent: globalChatData.currentEvent,
      })

      // probably should ping regardless of globalchat
      // pingEventAttendeeActive(currentEventAttendee)
      joinEventAttendeeOnlineChannel(currentEventAttendee, echoInstance)
      joinedOnlineChannelFromChat = true
    }
  }
  
  if (typeof window.attendeeGlobalPresenceEnabled !== 'undefined') {
    if (window.attendeeGlobalPresenceEnabled == true) {
      if (typeof window.currentEventAttendee !== 'undefined') {
        // Event Attendee Online Channel
        if (!joinedOnlineChannelFromChat) {
          joinEventAttendeeOnlineChannel(window.currentEventAttendee, echoInstance)
        }
        // Plugin Presence Channel
        $(document).ready(function() {
          if (typeof window.pluginData !== 'undefined') {
            initEventAttendeePluginVisit(window.currentEventAttendee, window.pluginData, echoInstance)
          }
        })
      }
    }
  }

  if (document.getElementById('nav-top-navigation')) {
    var globalNavigationController = window.globalNavigationController
    window.globalNavigationController = GlobalNavigationController('#nav-top-navigation', {
      // currentEvent: globalNavigationController.currentEvent,
    })
  } else if (document.getElementById('nav-side-navigation')) {
    var globalNavigationController = window.globalNavigationController
    window.globalNavigationController = GlobalNavigationController('#nav-side-navigation', {
      // currentEvent: globalNavigationController.currentEvent,
    })
  }
  // axios.post('/event_attendees_presence/')

  checkScroll()
})

$(function () {
  // Overflow fade
  // if ($('.navbar-nav.float-left').prop('scrollWidth') > $('.navbar-nav.float-left').prop('clientWidth')){
  //   $('.navbar-nav.float-left').addClass('overflow-fade')
  // }
  if (document.getElementById('photo-stream-app')) {
    window.photoStream = new Vue({ el: "#photo-stream-app" });
  }
  
  if (document.getElementById('points-allocation-page')) {
    window.pointsAllocationpage = new Vue({ el: "#points-allocation-page" });
  }
  
  if (document.getElementById('select-timezone')) {
    window.selectTimezone = new Vue({ el: "#select-timezone" });
  }
  if (document.getElementById('stripe-checkout-form')) {
    window.stripeCheckoutForm = new Vue({ el: "#stripe-checkout-form" });
  }
  if (document.getElementById('visa-shopping-cart')) {
    window.visaCheckoutForm = new Vue({ el: "#visa-shopping-cart" });
  }

  if (document.getElementById('form-domain-validation')) {
    window.formDomainValidation = new Vue({ el: "#form-domain-validation" });
  }

  if (document.getElementById('reg-code-validation')) {
    window.regCodeValidation = new Vue({ el: "#reg-code-validation" });
  }
    
  if (document.getElementById('select-language')) {
    window.SelectLanguage = new Vue({ el: "#select-language" });
  }

  if (document.getElementById('stream-conductor')) {
    window.streamConductor = new Vue({ el: "#stream-conductor" });
  }

  if (document.getElementById('chatbot-vue-container')) {
    window.chatBot = new Vue({ el: "#chatbot-vue-container" });
  }

    if (document.getElementById('kiosk-chat-agent-app')) {
      new Vue({ el: '#kiosk-chat-agent-app'});
  }

  moment.locale(window.default_locale)

  var notificationsConfigElement = document.getElementById('js-attendee-notifications')
  if (notificationsConfigElement) {
    var notificationsConfig = JSON.parse(notificationsConfigElement.dataset.config)
    window.AttendeeNotificationsController = initAttendeeNotifications('#notifications', notificationsConfig, window);
  }
  initMobileNavToggles()
})

$(window).scroll(function () {
  checkScroll()
});

window.initHtml5QrcodeScanner = initHtml5QrcodeScanner
